import IntersectionObserverManager from 'nespresso-library/src/utils/IntersectionObserverManager'
import debounce from 'nespresso-library/src/utils/debounce'

class Parallax {
    constructor (minWidth = 767) {
        this.items = [] // Items to apply parallax
        this.itemsInVp = [] // Items in viewport to parallax
        this.minWidth = minWidth // Screen width to activate the parallax
        this.active = this.getActive() // Enable/Disable parallax
        this.iom = new IntersectionObserverManager({
            isLandscape: {
                rootMargin: '200% 0px'
            },
            isPortrait: {
                rootMargin: '200% 0px'
            }
        })

        this.scrollEvent = () => {
            this.move()
        }
        this.resizeEvent = debounce(() => {
            this.reset()
            this.move()
        }, 500)
    }

    getActive () {
        return this.minWidth <= window.innerWidth
    }

    add (el, { modifiers, value }) {
        // Exclude element with no speed
        if (!this.getActive() || value === 0) {
            return
        }
        el.style.transition = 'none'
        el.style.willChange = 'transform'
        const style = el.currentStyle || window.getComputedStyle(el)
        const height = modifiers.absY ? window.innerHeight : el.clientHeight || el.offsetHeight || el.scrollHeight
        const offsetTopParent = el.offsetParent ? el.offsetParent.offsetTop : 0

        // Add element in general array with all calcul
        this.items.push({
            el: el,
            initialOffsetTop: el.offsetTop + offsetTopParent - parseInt(style.marginTop, 10),
            style: style,
            modifiers: modifiers,
            value: value,
            clientHeight: height
        })

        // Observe element
        this.iom.addItem({
            element: el,
            onViewportEnter: () => {
                this.parallaxItem(el)
            },
            onViewportOut: () => {
                this.unparallaxItem(el)
            }
        })
    }

    parallaxItem (el) {
        this.itemsInVp.push(this.items.find(item => item.el === el))
    }

    unparallaxItem (el) {
        this.itemsInVp = this.itemsInVp.filter(item => item.el !== el)
    }

    move () {
        requestAnimationFrame(() => {
            const windowHeight = window.innerHeight
            const windowSize = (window.scrollY || window.pageYOffset) + windowHeight

            this.itemsInVp.map((item) => {
                const elH = item.clientHeight
                let offset = item.initialOffsetTop
                let pos = windowSize
                pos = pos - elH / 2
                pos = pos - windowHeight / 2
                pos = pos * item.value

                offset = item.initialOffsetTop
                offset = offset * -1
                offset = offset * item.value
                pos = pos + offset

                pos = pos.toFixed(2)

                this.setTransform(item, `translateY(${pos}px)`)
            })
        })
    }

    // Remove all transformations
    reset () {
        this.active = this.getActive()
        if (!this.active) {
            this.disableParallax()
        } else {
            this.enableParallax()
        }
        requestAnimationFrame(() => {
            this.items.map(item => {
                item.el.style = item.style
            })
        })
    }

    enable () {
        if (this.items.length === 0) {
            return
        }

        this.enableParallax()
    }

    disableParallax () {
        this.itemsInVp = []
        this.iom.unobserveItems()
        this.disableEvent()
    }

    enableParallax () {
        this.iom.observeItems()
        this.enableEvent()
    }

    disableEvent () {
        window.removeEventListener('scroll', this.scrollEvent)
        window.removeEventListener('resize', this.resizeEvent)
    }

    enableEvent () {
        window.addEventListener('scroll', this.scrollEvent, { passive: true })
        window.addEventListener('resize', this.resizeEvent, { passive: true })
    }

    // Apply style on item
    setTransform (item, value) {
        if (item.modifiers.centerX) {
            value += ' translateX(-50%)'
        }

        const el = item.el
        const prop = 'Transform'
        el.style[`webkit${prop}`] = value
        el.style[`moz${prop}`] = value
        el.style[`ms${prop}`] = value
    }
}

export default {
    install: (Vue, { minWidth }) => {
        const p = new Parallax(minWidth)

        Vue.prototype.$parallaxjs = p
        Vue.directive('parallax', {
            inserted (el, binding) {
                p.add(el, binding)
                p.move()
                p.enable()
            }
        })
    }
}
